import { useWallet, WalletReadyState } from "@manahippo/aptos-wallet-adapter";
import { WalletAdapter } from "@manahippo/aptos-wallet-adapter/src/WalletAdapters/BaseAdapter";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import SettingsIcon from "../../imgs/settings.png";
import { set } from "../../store/wallet";
import { short_address } from "../../utils/common";
import Button from "../Common/Button";
import ModalDialog from "../Modal";

type Props = {
  local: number;
};

export default function LoginWallet(props: Props) {
  const { connected, account, network, wallets, wallet, ...rest } = useWallet();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("Connect Wallet");

  useMemo(() => {
    if (connected && account && account.address) {
      dispatch(set(account.address.toString()));
      setTitle("Account");
    }
  }, [connected, account, dispatch]);

  const handleChange = async () => {
    await rest.disconnect();
    setTitle("Connect Wallet");
  };

  const handleConnect = async (item: WalletAdapter) => {
    await rest.connect(item.name);
    handleClose();
  };

  async function handlerDisconnect() {
    handleClose();
    await rest.disconnect();
    setTitle("Connect Wallet");
    dispatch(set(""));
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="flex p-4 cursor-pointer">
      {wallet && account ? (
        <div className="flex justify-between items-center w-full gap-3">
          <div className="flex items-center gap-3 text-white text-lg text-center ">
            <img width={40} alt="" src={wallet.adapter.icon} />
            {short_address((account?.address || "")?.toString())}
          </div>

          <img
            src={SettingsIcon}
            onClick={async () => {
              handleClickOpen();
            }}
            alt=""
          />
        </div>
      ) : (
        <Button
          fullWidth
          className="bg-blue-500"
          onClick={async () => {
            !account && handleClickOpen();
          }}
        >
          Connect Wallet
        </Button>
      )}

      <ModalDialog open={open} handleClose={handleClose} title={title}>
        {account?.address ? (
          <div className="flex flex-col gap-4 my-4 mx-6 border rounded-3xl border-white border-opacity-30 p-4">
            <div className="flex justify-between">
              <p className="text-white">Connected</p>
              <button
                className="bg-blue-500 rounded-full px-4 py-1 text-white"
                onClick={handleChange}
              >
                Change
              </button>
            </div>
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                {wallet && (
                  <img width={30} alt="" src={wallet?.adapter?.icon} />
                )}
                <p className="text-white text-lg">
                  {short_address(account.address.toString())}
                </p>
              </div>
              <button
                onClick={handlerDisconnect}
                className="border rounded-full border-blue-400 px-4 py-1 text-white"
              >
                Disconnect Wallet
              </button>
            </div>
            <div className="flex justify-center gap-6">
              <button
                className="text-white"
                onClick={() => {
                  if (account && account.address)
                    navigator.clipboard.writeText(account.address.toString());
                }}
              >
                Copy Address
              </button>
              <button className="text-white">View on Ethereum</button>
            </div>
          </div>
        ) : (
          <div className="flex py-4 px-6 flex-col gap-4 h-96">
            {wallets
              .filter((item, key) => {
                return key !== 0;
              })
              .map((item) => {
                return (
                  <div
                    className="flex justify-between items-center pb-4 border-b border-white border-opacity-20"
                    key={item.adapter.name}
                  >
                    <div className="flex items-center gap-4">
                      <img
                        width={40}
                        className="rounded-full"
                        alt={item.adapter.name}
                        src={item.adapter.icon}
                      />
                      <div className="text-white">{item.adapter.name}</div>
                    </div>
                    <div>
                      <Button
                        onClick={async () => {
                          await handleConnect(item.adapter);
                        }}
                        className="bg-blue-500 rounded-full px-4 py-1 text-white"
                      >
                        {item.readyState === WalletReadyState.Installed
                          ? "Connect Wallet"
                          : "Go to Install"}
                      </Button>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </ModalDialog>
    </div>
  );
}
